// eslint-disable-next-line no-process-env
export default process.env.REACT_APP_GRAPH_URI



// WEBPACK FOOTER //
// ./client/modules/debate/constants/endpoint.js